import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/contexts/AuthContext";
import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import OnboardingPage from "@/pages/OnboardingPage";
import ProfileCreatePage from "@/pages/ProfileCreatePage";
import ChatPage from "@/pages/ChatPage";
import DiaryPage from "@/pages/DiaryPage";
import SettingsPage from "@/pages/SettingsPage";
import PolicyPage from "@/pages/PolicyPage";
import PersonalityPage from "@/pages/PersonalityPage";
import PreorderPage from "@/pages/PreorderPage";
import PreorderSuccessPage from "@/pages/PreorderSuccessPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen flex items-center justify-center bg-background"><div className="w-6 h-6 border-2 border-primary border-t-transparent rounded-full animate-spin" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
      <Route path="/profile/create" element={<ProtectedRoute><ProfileCreatePage /></ProtectedRoute>} />
      <Route path="/profile/:profileId/personality" element={<ProtectedRoute><PersonalityPage /></ProtectedRoute>} />
      <Route path="/chat/:profileId" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
      <Route path="/diary" element={<ProtectedRoute><DiaryPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/policy" element={<ProtectedRoute><PolicyPage /></ProtectedRoute>} />
      <Route path="/preordine" element={<PreorderPage />} />
      <Route path="/preordine/successo" element={<PreorderSuccessPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<AdminDashboardPage />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground font-sans">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
